import * as React from 'react';
import { Col, Collapse, Row } from 'reactstrap';
import { Svg } from 'src/components/shared/Svg';
import { IProject, IProposition } from 'src/model';
import { ProjectPropositionCardWithGlobalContext } from './ProjectPropositionCard/ProjectPropositionCard';

interface IPropositionListProps {
  label: string;
  propositionList: IProposition[];
  src: string;
  filter: (project: IProposition) => boolean;
  handlePropositionListChange: () => void;
  handleProjectChange?: (project : IProject) => void;
}

export const PropositionList: React.SFC<IPropositionListProps> = ({
  label,
  filter,
  handleProjectChange,
  handlePropositionListChange,
  propositionList,
  src,
}) => {
  const [collapse, toggleCollapse] = React.useState({
    isOpen: true,
  });
  const filteredPropositionList = propositionList.filter(filter);

  return (
    <>
      <Row className='d-flex justify-content-between border-bottom mb-4'>
        <Col md='11'>
          <h5 className='text-uppercase text-dark'>
            <Svg width={32} fill='dark' src={src} className='mr-2' />
            {`${label} 
            ${filteredPropositionList.length
                 ? `(${filteredPropositionList.length})`
                : ''
            }`
            }
          </h5>
        </Col>
        <Col md='1'>
          <Svg
            width={32}
            fill='dark'
            src='down'
            onClick={() => toggleCollapse({ isOpen: !collapse.isOpen })}
            style={{
              transform: collapse.isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </Col>
      </Row>
      <Collapse isOpen={collapse.isOpen}>
        <Row>
          {filteredPropositionList.map(
            (proposition: IProposition, key: number) => (
              <Col key={key} md='12'>
                <ProjectPropositionCardWithGlobalContext
                  proposition={proposition}
                  handlePropositionListChange={handlePropositionListChange}
                  handleProjectChange={handleProjectChange}
                />
              </Col>
            )
          )}
        </Row>
      </Collapse>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/components/Project/ProjectPropositions/PropositionList.tsx